import {
  AddressInfo,
  BatchAndStockBatchDue,
  BatchInfo, GenericApiErrors, GetAddressByBatchParams, GetBatchDetailParams, ProductBatchInfo,
} from './BasicQueriesTypes'
import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'

const getAddressByBatch = async (payload: GetAddressByBatchParams) => {
  try {
    const { batch } = payload
    const result = await http.get(`/v2/basic-query/batch/${batch}`)

    return parseGoodResponse<BatchInfo>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getBatchDetail = async ({ address, batch }: GetBatchDetailParams) => {
  try {
    const resultSuccess = await http.get(`v2/basic-query/address/${address}/batches`, {
      params: {
        id_batch_or_product_code: batch,
      },
    })
    return parseGoodResponse<BatchAndStockBatchDue[]>(resultSuccess.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getProductInfoByBarcode = async (barcode: string) => {
  try {
    const resultSuccess = await http.get(`v2/basic-query/product/${barcode}`)

    return parseGoodResponse<ProductBatchInfo>(resultSuccess.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getAddressInfo = async (address: string) => {
  try {
    const resultSuccess = await http.get(`v2/basic-query/address/${address}/products`)
    return parseGoodResponse<AddressInfo[]>(resultSuccess.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  getAddressByBatch,
  getBatchDetail,
  getAddressInfo,
  getProductInfoByBarcode,
}
